export default __webpack_public_path__ + "static/media/truck-weight.1a661348.webp";